import React from "react";

import "./Header.scss";

interface IProps extends React.HTMLAttributes<HTMLElement> {
    children?: React.ReactNode;
}

export default function Header({ children, className, ...props }: IProps) {
    const classNames = ["userful-header", "noselect", className].filter(Boolean).join(" ");

    return (
        <header className={classNames} {...props}>
            {children}
        </header>
    );
}
